module.exports = __webpack_public_path__ + "static/trash-81fa9e6a4136f3995100805b78bbf780.jpg";